import React, {useEffect, useLayoutEffect, useRef} from "react";
import {useTranslation} from "react-i18next";
import {Container, Row} from "react-bootstrap";
import {StyleDiv, StyleDivCenterChild} from "components/Common/StyleDiv";
import DownloadOnTheAppStoreButton from "components/SignIn/DownloadOnTheAppStoreButton";
import {Logo} from "components/SignIn/Logo";
import LogoWithBackground from "components/SignIn/LogoWithBackground";
import {LogoWithBackgroundContainer} from "components/SignIn/LogoWithBackgroundContainer";
import OAuthSignInButtons from "components/SignIn/OAuthSignInButtons";
import SignInForm from "components/SignIn/SignInForm";
import {SignInFormContainer} from "components/SignIn/SignInFormContainer";
import {PAGE_URLS, WATERSPEED_PLAY_STORE_LINK} from "constants/AppConstants.js";
import {StyleLabel} from "components/Common/StyleLabel";
import {ws} from "styles/tokens";
import {StyleImageButton} from "components/Common/StyleButton";
import {StyleLink} from "components/Common/StyleLink";
import {customSetScreenView, isAndroid} from "FirebaseUtils";
import {Redirect, withRouter} from "react-router-dom";
import {useAppUser} from "contexts/AppUserContext";
import {SignUpButton} from "components/SignIn/SignInButton";
import LegalLinks from "components/Common/LegalLinks";
import {
  handleGarminService,
  handleGP3Service,
  handleSuuntoService,
  handleCorosService,
  handleStravaService
} from "utils/redirectExternalServicesHandler";

interface Props {
  history: any;
}

function SignInPage({history}: Props) {
  const {claims, user} = useAppUser();
  const {t} = useTranslation();

  const shouldRedirect = useRef(true);
  const willBeLoggedIn = useRef(false);

  useEffect(() => {
    (async () => {
      await customSetScreenView("SignInPage");
    })();
  }, []);

  useLayoutEffect(() => {
    // Get params activityId from localStorage and code from url then redirect to activity page
    shouldRedirect.current = handleGP3Service(history);
    shouldRedirect.current = handleGarminService(history) || shouldRedirect.current;
    shouldRedirect.current = handleSuuntoService(history) || shouldRedirect.current;
    shouldRedirect.current = handleCorosService(history) || shouldRedirect.current;
    shouldRedirect.current = handleStravaService(history) || shouldRedirect.current;
  }, []);

  if (user && claims && shouldRedirect.current && !isAndroid) {
    return <Redirect to={PAGE_URLS.diaryPageUrl} />;
  }

  if (isAndroid && !willBeLoggedIn.current) {
    return null;
  }

  return (
    !isAndroid && (
      <Container fluid>
        <Row className="g-0">
          <LogoWithBackgroundContainer>
            <LogoWithBackground />
          </LogoWithBackgroundContainer>
          <SignInFormContainer>
            <StyleDivCenterChild height={isAndroid ? "100vh" : "110vh"}>
              <Logo />
              <StyleDiv margin="0px 0px 30px 0px">
                <StyleLabel
                  fontSize="2.2rem"
                  fontWeight="400"
                  style={{fontFamily: ws.fontDisplay, letterSpacing: "-0.02em"}}
                >
                  {t("auth.signInTo")}
                </StyleLabel>
              </StyleDiv>
              <OAuthSignInButtons />
              <SignInForm />
              {!isAndroid && (
                <SignUpButton onClick={() => history.push(PAGE_URLS.onboardingPageUrl)}>
                  {t("auth.dontHaveAccountSignUp")}
                </SignUpButton>
              )}
              {isAndroid && (
                <SignUpButton onClick={() => history.push(PAGE_URLS.onboardingPageUrl)}>
                  {t("auth.dontHaveAccountSignUp")}
                </SignUpButton>
              )}
              {isAndroid && (
                <StyleDiv margin="20px 0px 0px 0px">
                  <StyleLink to={{pathname: WATERSPEED_PLAY_STORE_LINK}} target="_blank">
                    <StyleImageButton
                      alt="download-on-the-play-store-button"
                      src={`/assets/icons/download-playstore.png`}
                      width={140}
                      height={40}
                    />
                  </StyleLink>
                </StyleDiv>
              )}
              {!isAndroid && <DownloadOnTheAppStoreButton />}
              {!isAndroid && <LegalLinks />}
            </StyleDivCenterChild>
          </SignInFormContainer>
        </Row>
      </Container>
    )
  );
}

export default withRouter(SignInPage);
